import FontAwesomeIcon from "app/components/layouts/Icons/FontAwesome";
import { faTimes, faComments } from "@fortawesome/free-solid-svg-icons";

const ChatToggle = ({ toggle, isOpen }) => (
  <button
    onClick={toggle}
    className="chat-button btn position-fixed rounded-circle d-flex justify-content-center align-items-center shadow"
    aria-label="toggle chat"
    style={{
      bottom: '20px',
      left: '20px',
      width: '60px',
      height: '60px',
      backgroundColor: '#10CAF0',
      zIndex: 1000
    }}
  >
    <FontAwesomeIcon className="text-white text-size-2xl" icon={isOpen ? faTimes : faComments} />
  </button>
);

export default ChatToggle;
